import React from "react";
import ReportsTooltip from "./components/ReportsTooltip";

interface IProps {
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const Reports = (props: IProps) => {
  return (
    <>
      <ReportsTooltip {...props} />
    </>
  );
};

export default Reports;
